import { RowStatus } from "./styles";

export default function StatusOrders(props) {
  return <RowStatus bg={props.color}>{props.status}</RowStatus>;
}
